import { SgaLogo } from './SgaLogo';

/**
 * Logo exibida com a sidebar aberta.
 *
 * A 55px de altura o wordmark ocupa ~123px de largura, dentro dos ~200px úteis
 * da sidebar aberta e dos 96px de altura do container (3x `logoHeight`).
 */
export const LogoFull = () => <SgaLogo height={55} />;
